import state from "./state";
import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @returns {*}
   */
  async fetchTeacherAdminList(context) {
    try {
      ApiService.setHeader();
      context.commit("setTeacherAdminListBusy", true);
      const res = await ApiService.query("school/employee/teacher/privilege", {
        params: {
          "page[size]": 30,
          "page[number]": state.pagination.current_page ?? 1,
          "filter[first_name]": state.filters.name,
          role: state.filters.role ?? 1,
        },
      });

      context.commit("setTeacherAdminList", res.data.data);
      context.commit("setTeacherAdminListPagination", res.data.meta.pagination);
      return res;
    } catch (error) {
      console.error(error);

      throw Error("Failed.");
    } finally {
      context.commit("setTeacherAdminListBusy", false);
    }
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherAdminListNameFilters(context, payload) {
    console.log("Name", payload.name);

    let curFilters = state.filters;
    curFilters.name = payload.name;

    context.commit("setTeacherAdminListFilters", curFilters);
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherAdminListRoleFilters(context, payload) {
    console.log("ROle", payload.role);

    let curFilters = state.filters;
    curFilters.role = payload.role;

    context.commit("setTeacherAdminListFilters", curFilters);
  },
};
